import { Component, SimpleChanges, OnInit, Input, EventEmitter, Output, } from '@angular/core';
import * as _moment from 'moment';
import { TimeSheetService } from '../../services/time-sheet.service';

@Component({
  selector: 'app-date-picker',
  templateUrl: './date-picker.component.html',
  styleUrls: ['./date-picker.component.scss'],

})
export class DatePickerComponent implements OnInit {
  @Input('placeholder') placeholder
  @Input('date') date
  @Input('isshowMarkCheckBoxes') isshowMarkCheckBoxes
  @Input('maxDate') maxDate
  @Input('validation') dateValidation
  @Input('maxDateRequired') maxDateRequired
  @Input('minDate') minDate
  @Input('matError') matError
  @Input('isSubmit') isSubmit
  @Input('startDateRequired') startDateRequired
  // @Input('isDisable') isDisable
  @Input('isRequired') isRequired
  @Input('importMaxDate') importMaxDate
  @Input('startDate') startDate
  @Input('reset') reset
  @Input('isClear') isClear
  @Input('isReadOnly') isReadOnly
  @Input('isDisabled') isDisabled
  @Input('dateFilter') dateFilter
  @Input('type') viewType
  // @Input('isJobDate') isJobDate

  @Output() public newdate = new EventEmitter<any>();
  editdate
  isValidation
  forToggle
  minDateValidation
  minimumDate
  dateType
  // startDateRequired
  submit

  // datePicker: FormGroup
  constructor(
    public _timeSheetService: TimeSheetService
  ) { }

  ngOnInit() {
    // console.log('edit date picker');
    // console.log('edit date picker this.isReadOnly', this.isReadOnly);
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("CHANGES datepicker", changes);
    if (changes.date && changes.date.currentValue) {
      // console.log("this is before date value", this.editdate);

      // this.editdate = " "
      // if (changes.date && changes.date.currentValue) {
      this.editdate = new Date(changes.date.currentValue)
      console.log("edit date here ..", this.editdate)
      // 
    }
    else {
      console.log("call this else part for blank date");
      if (changes.date && !changes.date.previousValue) this.editdate = null
    }
    // console.log("this is after date value", this.editdate);

    if (changes.reset && changes.reset.currentValue == true) {
      // console.log("here is the reset call ==>")
      this.editdate = null
    }

    if (changes.startDate && changes.startDate.currentValue) {
      let startDate = new Date(changes.startDate.currentValue)
      // console.log("here is the current job  ----------->>>>>>> !!!!!!!", changes.startDate.currentValue)
      // this.placeholder = startDate.getDate() + '/' + (startDate.getMonth() + 1) + '/' + startDate.getFullYear()
      // this.getSystemDate()
    }

    if (changes.startDateRequired && changes.startDateRequired.currentValue) {
      if (changes.startDateRequired.currentValue == true) {
        // this.getSystemDate()
      }
    }

    if (changes.isSubmit && changes.isSubmit.currentValue) {
      this.submit = changes.isSubmit.currentValue
      // console.log("hello here is the submit current value...",this.submit)
    }

    if (changes.dateValidation && changes.dateValidation.currentValue == true) {
      this.isValidation = changes.dateValidation.currentValue
      // this.getSystemDate()
    }


    if (changes.isshowMarkCheckBoxes && changes.isshowMarkCheckBoxes.currentValue) {
      this.forToggle = (changes.isshowMarkCheckBoxes.currentValue == false) ? false : true
    }
    else {
      this.forToggle = true
    }

    if (changes.minDate && changes.minDate.currentValue) this.minimumDate = new Date(changes.minDate.currentValue)
    console.log("what is the date validation for min date", this.minimumDate);
    if (changes.maxDate && changes.maxDate.currentValue) this.maxDate = new Date(changes.maxDate.currentValue)

    if (changes.viewType && changes.viewType.currentValue) this.dateType = changes.viewType.currentValue

  }

  dateFormate() {
    if (this.editdate) {
      this.date = new Date(this.editdate)
      // let date = this.date;
    }
    else {
      // this.date = new Date()
    }
    let date = this.date;

    console.log("changes of date !!!", date)
    console.log('edit date...', this.editdate)
    let newdateFormate

    // if (this.dateType == 'medical') {
    //   console.log("THis is for medical date picker");
    //   newdateFormate = ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + date.getFullYear()
    // } else {
    if (date) {
      newdateFormate = ((date.getMonth() > 8) ? (date.getMonth() + 1) : ('0' + (date.getMonth() + 1))) + '/' + ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())) + '/' + date.getFullYear()
      console.log("date formate chenge!!!", newdateFormate, ((date.getDate() > 9) ? date.getDate() : ('0' + date.getDate())),)
      this.newdate.emit(newdateFormate);
    }
  }

  clearDate(event) {
    this.editdate = ''
    event.stopPropagation();
    this.newdate.emit('');
  }


  getSystemDate() {
    console.log("get the max date !!!!", this.startDateRequired)

    if (this.startDateRequired == true) {
      this._timeSheetService.getSystemDate().subscribe((response) => {
        console.log("response of date response.systemDate", response);
        this.editdate = response.systemDate
      })
    }

    if (this.maxDateRequired == true) {
      this._timeSheetService.getSystemDate().subscribe((response) => {
        console.log("response of date response.systemDate", response);
        this.maxDate = (this.importMaxDate) ? this.importMaxDate : response.systemDate
      })
    }
    else {
      this.maxDate = null
    }
  }

}
